import React from "react";
import { withTranslation } from 'react-i18next';
import PropertyUnitNew from "./propertyUnitNew";

class PropertyUnitNewParent extends React.Component {
    constructor(props) {
        super(props);
        this.state = {

        }
    }
    render() {
        return <PropertyUnitNew  {...this?.props} />;
    }
}

export default withTranslation('propertyUnitNew')(PropertyUnitNewParent);